import api from '../../../api';
import { finish, error } from '../../../modules/roles/actions/get';

export function request(dispatch) {
    api.get('/roles').then(
        data => dispatch(finish(data.accountTypes)),
        ({ errors }) => dispatch(error(errors))
    );
}
